export const generateArray = (length: number) =>
  Array.from({ length }, (_, index) => index + 1);
